import { useEffect } from "react";
import { useAtom } from 'jotai';

import { darkModeAtom } from "../../App";

export default function DarkMode () {
    const [darkMode, setDarkMode] = useAtom(darkModeAtom);

    useEffect(() => {
        const previousDarkMode = localStorage.getItem('darkMode') === 'true';
        setDarkMode(previousDarkMode);
    }, [setDarkMode]);

    useEffect(() => {
        localStorage.setItem('darkMode', darkMode);
    }, [darkMode]);

    const toggleDarkMode = () => {
        setDarkMode((prevDarkMode) => !prevDarkMode);
    };

    const isDarkMode = darkMode ? 'dark' : '';

    return (
        <>
            <button title="Thème du site" onClick={toggleDarkMode} className={`w-12 h-6 rounded-full p-1 ${darkMode ? 'bg-blue-900' : 'bg-gray-200'} relative transition-colors duration-500 ease-in focus:outline-none focus:ring-2 ${darkMode ? 'focus:ring-blue-600' : 'focus:ring-blue-700'} focus:border-transparent`}>
                <div id="toggle" className={`rounded-full w-4 h-4 ${isDarkMode ? 'bg-gray-300' : 'bg-blue-800'} relative ml-0 ${darkMode ? 'ml-6' : ''} transition-all duration-300 ease-out`}>
                </div>
            </button>
        </>
    )
}